export default __webpack_public_path__ + "static/media/lotus.f4c577e9.svg";